var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.75C20.4142 11.75 20.75 12.0858 20.75 12.5C20.75 12.9142 20.4142 13.25 20 13.25H10.75L10.75 18.5C10.75 18.8034 10.5673 19.0768 10.287 19.1929C10.0068 19.309 9.68417 19.2449 9.46967 19.0304L3.46967 13.0304C3.32902 12.8897 3.25 12.6989 3.25 12.5C3.25 12.3011 3.32902 12.1103 3.46967 11.9697L9.46967 5.96969C9.68417 5.75519 10.0068 5.69103 10.287 5.80711C10.5673 5.9232 10.75 6.19668 10.75 6.50002L10.75 11.75H20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.e37a4b5792aef0bf2086685a423214b2.svg";
export { ForwardRef as ReactComponent };